import { useEffect } from 'react';

import { Link } from 'react-router-dom';

import { LandingFooter } from '@pages/LandingPage/ui/LandingFooter';

import { ROUTES } from '@shared/config/routes';
import { cn } from '@shared/lib/utils';
import { buttonVariants } from '@shared/ui/button';
import { CortexaLogo } from '@shared/ui/cortexa-logo';

const goHomeButtonLabel = 'Return home';

export const NotFoundPage = () => {
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0 });
  }, []);

  return (
    <div className="min-h-dvh w-screen">
      <main
        className="
          px-4 pt-48 pb-32
          sm:px-6
          lg:px-8
        "
      >
        <div
          className="
            mx-auto flex min-h-[max(36rem,calc(100dvh-24rem))] w-full max-w-3xl items-center
            justify-center
          "
        >
          <div
            className="
              flex size-full flex-col items-center justify-center text-center text-foreground
            "
          >
            <CortexaLogo
              size="lg"
              icon={true}
              keepColors={false}
              className="relative size-24 text-background-4 drop-shadow-recess"
            />
            <div className="mt-8 flex max-w-md flex-col gap-2">
              <h1 className="text-6xl font-medium">404</h1>
              <p className="text-xl font-medium">Page not found</p>
              <p className="mt-2 mb-6 text-balance text-muted-foreground">
                Sorry, the page you are looking for doesn&apos;t exist or has been moved
              </p>
            </div>

            <Link
              to={ROUTES.HOME}
              className={cn(buttonVariants({ variant: 'default', size: 'lg' }), 'h-10')}
              aria-label={goHomeButtonLabel}
            >
              {goHomeButtonLabel}
            </Link>
          </div>
        </div>
      </main>

      <LandingFooter />
    </div>
  );
};
